import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/google2.svg'
import _imports_1 from '@/assets/images/slack.svg'
import _imports_2 from '@/assets/images/git.svg'
import _imports_3 from '@/assets/images/mailchimp.svg'
import _imports_4 from '@/assets/images/asana.svg'
import _imports_5 from '@/assets/images/facebook3.svg'
import _imports_6 from '@/assets/images/twitter.svg'
import _imports_7 from '@/assets/images/instagram.svg'
import _imports_8 from '@/assets/images/dribbble2.svg'
import _imports_9 from '@/assets/images/behance.svg'


const _hoisted_1 = { class: "card bg-white border-0 rounded-3 mb-4" }
const _hoisted_2 = { class: "card-body p-4" }
const _hoisted_3 = { class: "default-table-area connected-table border-bottom pb-3 mb-4" }
const _hoisted_4 = { class: "table-responsive" }
const _hoisted_5 = { class: "table align-middle border-0" }
const _hoisted_6 = { class: "text-end" }
const _hoisted_7 = { class: "text-end" }
const _hoisted_8 = { class: "text-end" }
const _hoisted_9 = { class: "text-end" }
const _hoisted_10 = { class: "text-end" }
const _hoisted_11 = { class: "default-table-area connected-table" }
const _hoisted_12 = { class: "table-responsive" }
const _hoisted_13 = { class: "table align-middle border-0" }
const _hoisted_14 = { class: "text-end" }
const _hoisted_15 = { class: "text-end" }
const _hoisted_16 = { class: "text-end" }
const _hoisted_17 = { class: "text-end" }
const _hoisted_18 = { class: "text-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SettingsMenu = _resolveComponent("SettingsMenu")!
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_SettingsMenu),
      _cache[20] || (_cache[20] = _createElementVNode("h4", { class: "fs-18 mb-2" }, "Connected Accounts", -1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("table", _hoisted_5, [
            _createElementVNode("tbody", null, [
              _createElementVNode("tr", null, [
                _cache[1] || (_cache[1] = _createElementVNode("td", { class: "ps-0" }, [
                  _createElementVNode("div", { class: "d-flex align-items-center" }, [
                    _createElementVNode("img", {
                      src: _imports_0,
                      alt: "google2"
                    }),
                    _createElementVNode("div", { class: "ms-3" }, [
                      _createElementVNode("span", { class: "fw-semibold text-dark" }, "Google"),
                      _createElementVNode("p", { class: "fs-14 text-body fw-normal" }, " Calendar and Contacts ")
                    ])
                  ])
                ], -1)),
                _createElementVNode("td", _hoisted_6, [
                  _createVNode(_component_RouterLink, {
                    to: "/settings/connections",
                    class: "text-decoration-none text-primary fs-14"
                  }, {
                    default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                      _createTextVNode(" Click to Disconnect ", -1)
                    ]))]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("tr", null, [
                _cache[3] || (_cache[3] = _createElementVNode("td", { class: "ps-0" }, [
                  _createElementVNode("div", { class: "d-flex align-items-center" }, [
                    _createElementVNode("img", {
                      src: _imports_1,
                      alt: "slack"
                    }),
                    _createElementVNode("div", { class: "ms-3" }, [
                      _createElementVNode("span", { class: "fw-semibold text-dark" }, "Slack"),
                      _createElementVNode("p", { class: "fs-14 text-body fw-normal" }, "Communications")
                    ])
                  ])
                ], -1)),
                _createElementVNode("td", _hoisted_7, [
                  _createVNode(_component_RouterLink, {
                    to: "/settings/connections",
                    class: "text-decoration-none text-primary fs-14"
                  }, {
                    default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                      _createTextVNode(" Click to Disconnect ", -1)
                    ]))]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("tr", null, [
                _cache[5] || (_cache[5] = _createElementVNode("td", { class: "ps-0" }, [
                  _createElementVNode("div", { class: "d-flex align-items-center" }, [
                    _createElementVNode("img", {
                      src: _imports_2,
                      alt: "git"
                    }),
                    _createElementVNode("div", { class: "ms-3" }, [
                      _createElementVNode("span", { class: "fw-semibold text-dark" }, "Github"),
                      _createElementVNode("p", { class: "fs-14 text-body fw-normal" }, " Manage your Git repositories ")
                    ])
                  ])
                ], -1)),
                _createElementVNode("td", _hoisted_8, [
                  _createVNode(_component_RouterLink, {
                    to: "/settings/connections",
                    class: "text-decoration-none text-primary fs-14"
                  }, {
                    default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                      _createTextVNode(" Click to Disconnect ", -1)
                    ]))]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("tr", null, [
                _cache[7] || (_cache[7] = _createElementVNode("td", { class: "ps-0" }, [
                  _createElementVNode("div", { class: "d-flex align-items-center" }, [
                    _createElementVNode("img", {
                      src: _imports_3,
                      alt: "mailchimp"
                    }),
                    _createElementVNode("div", { class: "ms-3" }, [
                      _createElementVNode("span", { class: "fw-semibold text-dark" }, "Mailchimp"),
                      _createElementVNode("p", { class: "fs-14 text-body fw-normal" }, " Email marketing service ")
                    ])
                  ])
                ], -1)),
                _createElementVNode("td", _hoisted_9, [
                  _createVNode(_component_RouterLink, {
                    to: "/settings/connections",
                    class: "text-decoration-none text-primary fs-14"
                  }, {
                    default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                      _createTextVNode(" Click to Disconnect ", -1)
                    ]))]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("tr", null, [
                _cache[9] || (_cache[9] = _createElementVNode("td", { class: "ps-0" }, [
                  _createElementVNode("div", { class: "d-flex align-items-center" }, [
                    _createElementVNode("img", {
                      src: _imports_4,
                      alt: "asana"
                    }),
                    _createElementVNode("div", { class: "ms-3" }, [
                      _createElementVNode("span", { class: "fw-semibold text-dark" }, "Asana"),
                      _createElementVNode("p", { class: "fs-14 text-body fw-normal" }, "Communication")
                    ])
                  ])
                ], -1)),
                _createElementVNode("td", _hoisted_10, [
                  _createVNode(_component_RouterLink, {
                    to: "/settings/connections",
                    class: "text-decoration-none text-primary fs-14"
                  }, {
                    default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                      _createTextVNode(" Click to Disconnect ", -1)
                    ]))]),
                    _: 1
                  })
                ])
              ])
            ])
          ])
        ])
      ]),
      _cache[21] || (_cache[21] = _createElementVNode("h4", { class: "fs-18 mb-2" }, "Social Accounts", -1)),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("table", _hoisted_13, [
            _createElementVNode("tbody", null, [
              _createElementVNode("tr", null, [
                _cache[11] || (_cache[11] = _createElementVNode("td", { class: "ps-0" }, [
                  _createElementVNode("div", { class: "d-flex align-items-center" }, [
                    _createElementVNode("img", {
                      src: _imports_5,
                      alt: "facebook2"
                    }),
                    _createElementVNode("div", { class: "ms-3" }, [
                      _createElementVNode("span", { class: "fw-semibold text-dark" }, "Facebook"),
                      _createElementVNode("p", { class: "fs-14 text-body fw-normal" }, " Calendar and Contacts ")
                    ])
                  ])
                ], -1)),
                _createElementVNode("td", _hoisted_14, [
                  _createVNode(_component_RouterLink, {
                    to: "/settings/connections",
                    class: "text-decoration-none text-primary fs-14"
                  }, {
                    default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                      _createTextVNode(" Click to Disconnect ", -1)
                    ]))]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("tr", null, [
                _cache[13] || (_cache[13] = _createElementVNode("td", { class: "ps-0" }, [
                  _createElementVNode("div", { class: "d-flex align-items-center" }, [
                    _createElementVNode("img", {
                      src: _imports_6,
                      alt: "twitter"
                    }),
                    _createElementVNode("div", { class: "ms-3" }, [
                      _createElementVNode("span", { class: "fw-semibold text-dark" }, "Twitter"),
                      _createElementVNode("p", { class: "fs-14 text-body fw-normal" }, "Communications")
                    ])
                  ])
                ], -1)),
                _createElementVNode("td", _hoisted_15, [
                  _createVNode(_component_RouterLink, {
                    to: "/settings/connections",
                    class: "text-decoration-none text-primary fs-14"
                  }, {
                    default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
                      _createTextVNode(" Click to Disconnect ", -1)
                    ]))]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("tr", null, [
                _cache[15] || (_cache[15] = _createElementVNode("td", { class: "ps-0" }, [
                  _createElementVNode("div", { class: "d-flex align-items-center" }, [
                    _createElementVNode("img", {
                      src: _imports_7,
                      alt: "instagram"
                    }),
                    _createElementVNode("div", { class: "ms-3" }, [
                      _createElementVNode("span", { class: "fw-semibold text-dark" }, "Instagram"),
                      _createElementVNode("p", { class: "fs-14 text-body fw-normal" }, " Manage your Git repositories ")
                    ])
                  ])
                ], -1)),
                _createElementVNode("td", _hoisted_16, [
                  _createVNode(_component_RouterLink, {
                    to: "/settings/connections",
                    class: "text-decoration-none text-primary fs-14"
                  }, {
                    default: _withCtx(() => [...(_cache[14] || (_cache[14] = [
                      _createTextVNode(" Click to Disconnect ", -1)
                    ]))]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("tr", null, [
                _cache[17] || (_cache[17] = _createElementVNode("td", { class: "ps-0" }, [
                  _createElementVNode("div", { class: "d-flex align-items-center" }, [
                    _createElementVNode("img", {
                      src: _imports_8,
                      alt: "dribbble2"
                    }),
                    _createElementVNode("div", { class: "ms-3" }, [
                      _createElementVNode("span", { class: "fw-semibold text-dark" }, "Dribbble"),
                      _createElementVNode("p", { class: "fs-14 text-body fw-normal" }, " Email marketing service ")
                    ])
                  ])
                ], -1)),
                _createElementVNode("td", _hoisted_17, [
                  _createVNode(_component_RouterLink, {
                    to: "/settings/connections",
                    class: "text-decoration-none text-primary fs-14"
                  }, {
                    default: _withCtx(() => [...(_cache[16] || (_cache[16] = [
                      _createTextVNode(" Click to Disconnect ", -1)
                    ]))]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("tr", null, [
                _cache[19] || (_cache[19] = _createElementVNode("td", { class: "ps-0" }, [
                  _createElementVNode("div", { class: "d-flex align-items-center" }, [
                    _createElementVNode("img", {
                      src: _imports_9,
                      alt: "behance"
                    }),
                    _createElementVNode("div", { class: "ms-3" }, [
                      _createElementVNode("span", { class: "fw-semibold text-dark" }, "Behance"),
                      _createElementVNode("p", { class: "fs-14 text-body fw-normal" }, "Communication")
                    ])
                  ])
                ], -1)),
                _createElementVNode("td", _hoisted_18, [
                  _createVNode(_component_RouterLink, {
                    to: "/settings/connections",
                    class: "text-decoration-none text-primary fs-14"
                  }, {
                    default: _withCtx(() => [...(_cache[18] || (_cache[18] = [
                      _createTextVNode(" Click to Disconnect ", -1)
                    ]))]),
                    _: 1
                  })
                ])
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}